import type { GetDisbursementPayoutDraftsParams } from 'api';

import type { GlobalFiltersState } from 'reduxLocal/slices/globalFiltersSlice';

import type { LocalState } from './localState';

type Params = LocalState & GlobalFiltersState;

export const apiParams = function (
  state: Partial<Params>
): GetDisbursementPayoutDraftsParams {
  // Build filter params
  const filterParams = {
    ...(state.filters?.status && {
      status: state.filters.status
    })
  };

  // Build pagination params
  const pageParams = {
    ...(state.cursorBefore && { cursor_before: state.cursorBefore }),
    ...(state.cursorAfter && { cursor_after: state.cursorAfter }),
    ...(state.includeCursor && { include_cursor: state.includeCursor })
  };

  // Build date range params
  const dateRangeParams = {
    ...(state.dateRange?.from && { created_after: state.dateRange.from }),
    ...(state.dateRange?.to && { created_before: state.dateRange.to })
  };

  // Combine params
  const params: GetDisbursementPayoutDraftsParams = {
    'page[cursor_after]': pageParams.cursor_after,
    'page[cursor_before]': pageParams.cursor_before,
    'page[include_cursor]': pageParams.include_cursor,
    'filter[status]': filterParams.status,
    created_after: dateRangeParams.created_after,
    created_before: dateRangeParams.created_before
  };

  return params;
};
